export const fontsArray = [
  "'Poppins', sans-serif",
  "'Anonymous Pro', monospace",
  "'Arimo', sans-serif",
];
